export class CheckSoItemExistReq{
    soId : number;
    jobId : number;
    varientId ?: number;
    packStyleId ?: number

    constructor(soId:number,jobId:number,varientId ?: number,packStyleId?:number){
        this.soId = soId
        this.jobId = jobId
        this.varientId =varientId
        this.packStyleId = packStyleId
    }
}